import {
  stockModel,
  pmxOverviewModel,
  pmxDetailModel,
  productionStockModel,
  rawMaterialStockOverviewModel,
  rawMaterialStockModel,
  customerStatusModel,
  customerOrderModel,
  deliveryModel,
  reserveStockModel,
  usageL36M2Model,
  usageL36M2V2Model,
  valueL36MModel,
  invoiceDNDetailModel,
} from "../../models/reportsModel";
import { ReadOnlyProps } from "../../utils/templates";

interface props {
  //Stock Report
  stockReportList: Array<stockModel>;
  isStockReportListLoaded: boolean;
  stockReportFilterCategoryList: Array<string>;
  lastRefreshStockReport: string;

  //Reserve Stock Report
  reserveStockReport: Array<reserveStockModel>;
  isReserveStockReportListLoaded: boolean;

  //Search Product Report
  productReportList: Array<stockModel>;
  isProductReportListLoaded: boolean;
  productReportFilterCategoryList: Array<string>;
  lastRefreshProductReport: string;

  //Customer Status Report
  customerStatusReport: Array<customerStatusModel>;
  isCustomerStatusReportListLoaded: boolean;

  //Customer Order Report
  customerOrderReport: Array<customerOrderModel>;
  isCustomerOrderReportListLoaded: boolean;

  //PMX Inventory Report
  pmxInventoryReport: Array<pmxOverviewModel>;
  isPmxInventoryReportListLoaded: boolean;

  //PMX Inventory Detail Report
  pmxInventoryDetailReport: Array<pmxDetailModel>;
  pmxInventoryDetailFilterCategoryList: Array<string>;
  isPmxInventoryDetailReportListLoaded: boolean;


  //Delivery Report
  deliveryReport: Array<deliveryModel>;
  isDeliveryReportListLoaded: boolean;

  //Production Stock Report
  productionStockReport: Array<productionStockModel>;
  isProductionStockReportListLoaded: boolean;

  //Raw Material OverView
  rawMaterialOverviewReport: Array<rawMaterialStockOverviewModel>;
  isRawMaterialOverviewReportListLoaded: boolean;

  //Raw Material Stock
  rawMaterialStockReport: Array<rawMaterialStockModel>;
  isRawMaterialStockReportListLoaded: boolean;

  //Sales Scorecard
  usageL36M2Report: Array<usageL36M2Model>;
  isUsageL36M2ReportListLoaded: boolean;

  //Usage Sales Scorecard
  usageL36M2V2Report: Array<usageL36M2V2Model>;
  isUsageL36M2V2ReportListLoaded: boolean;

  //Value Sales Scorecard
  valueL36MReport: Array<valueL36MModel>;
  isValueL36MReportListLoaded: boolean;

  //Invoice DN Detail
  invoiceDNDetailReport: Array<invoiceDNDetailModel>;
  isInvoiceDNDetailReportListLoaded: boolean;

  usageL36M2V2HiddenColumns: Array<string>;
  valueL36MHiddenColumns: Array<string>;
  invoiceDNDetailHiddenColumns: Array<string>;

  usageL36M2V2ColumnOrder: Array<string>;
  valueL36MColumnOrder: Array<string>;
  invoiceDNDetailColumnOrder: Array<string>;
}

export const reportsState: ReadOnlyProps<props> = {
  //Filled via dynamic stream
  stockReportList: [],
  isStockReportListLoaded: false,
  lastRefreshStockReport: "",
  stockReportFilterCategoryList: [
    "all",
    "produce",
    "berry",
    "meat",
    "meals",
    "salad",
    "bakery",
    "NSW",
    "VIC",
    "QLD",
    "WA",
    "SA",
    "TAS",
  ],
  reserveStockReport: [],
  isReserveStockReportListLoaded: false,
  productReportList: [],
  isProductReportListLoaded: false,
  lastRefreshProductReport: "",
  productReportFilterCategoryList: [
    "all",
    "produce",
    "berry",
    "meat",
    "meals",
    "salad",
    "bakery",
  ],
  //Customer Status Report
  customerStatusReport: [],
  isCustomerStatusReportListLoaded: false,

  //Customer Order Report
  customerOrderReport: [],
  isCustomerOrderReportListLoaded: false,

  //PMX Inventory Report
  pmxInventoryReport: [],
  isPmxInventoryReportListLoaded: false,

  //PMX Inventory Detail Report
  pmxInventoryDetailReport: [],
  pmxInventoryDetailFilterCategoryList: [
    "all",
    "NSW",
    "VIC",
    "QLD",
    "WA",
    "TAS",
  ],
  isPmxInventoryDetailReportListLoaded: false,

  //Production Stock Report
  productionStockReport: [],
  isProductionStockReportListLoaded: false,

  //Raw Material OverView
  rawMaterialOverviewReport: [],
  isRawMaterialOverviewReportListLoaded: false,

  //Raw Material Stock
  rawMaterialStockReport: [],
  isRawMaterialStockReportListLoaded: false,
  
  deliveryReport: [],
  isDeliveryReportListLoaded: false,

  usageL36M2Report: [],
  isUsageL36M2ReportListLoaded: false,

  usageL36M2V2Report: [],
  isUsageL36M2V2ReportListLoaded: false,

  valueL36MReport: [],
  isValueL36MReportListLoaded: false,

  invoiceDNDetailReport: [],
  isInvoiceDNDetailReportListLoaded: false,

  usageL36M2V2HiddenColumns: [],
  valueL36MHiddenColumns: [],
  invoiceDNDetailHiddenColumns: [],

  usageL36M2V2ColumnOrder: [],
  valueL36MColumnOrder: [],
  invoiceDNDetailColumnOrder: [],
};
